export const LABELS = {
  BACK: 'Your groups',
  NEW_GROUP: 'New group',
  NEW_GROUP_INFO:
    'A new group will be created with those invited below, along with your managed profiles',
  GROUP_NAME: 'Group name',
};
